import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const AdProductCard = ({ product }) => {
    // console.log(product)
    const [focusedImg, setFocusedImg] = useState(product?.files[0])

    const navigate = useNavigate()
    const { name } = useParams()

    return (
        <div className='ad'>
            <div className="user-product-card">
                <div className="user-product-img">
                    <img src={product?.files?.[0]?.url} alt={product?.title} />
                </div>
                <div className="user-product-details">
                    <div className="user-product-detail-header">
                        <h2>{product?.title}</h2>
                        <p className="user-product-price">${product?.price}</p>
                    </div>
                    <p className="user-product-description">{product?.description}</p>
                </div>
            </div>
            {/* Promote CTA */}
            <button className="promote-btn" onClick={() => navigate(`/b/manage/${name}/promotions/create`, { state: { ad: product, adType: "product" } })}>
                Promote
            </button>
        </div>
    )
}

export default AdProductCard